// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2GYTp","title":"Images45_title__3CT6K","images":"Images45_images__1deiN"};